var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('transition',{attrs:{"appear":""}},[(_vm.welif)?_c('p',{staticClass:"text-h4 text-center welcome"},[_vm._v("Welcome")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }